<template>
    <div class="contenedor_modal">
        <div class="contenedor_modal_cuerpo">
            <div class="contenedor_modal_cabecera">
                <b-button type="button" size="sm" v-shortkey="['esc']" @shortkey="cerrar" variant="danger"
                    @click="cerrar"><i class="fas fa-times"></i></b-button>
            </div>

            <b-container fluid="">
                <form @submit.prevent="actualizar_info">
                    <b-row>
                        <div class="col-sm-12 mt-2">
                            <h3>
                                Actualizar proveedor
                            </h3>
                        </div>
                        <div class="col-sm-12 mt-3">
                            <label for="" class="form-label">Nombre</label>
                            <input type="text" class="form-control form-control-sm" v-model="nombre">
                        </div>
                        <div class="col-sm-4 mt-3">
                            <label for="" class="form-label">NIT</label>
                            <input type="text" class="form-control form-control-sm" v-model="nit">
                        </div>

                        <div class="col-sm-4 mt-3">
                            <label for="" class="form-label">Teléfono</label>
                            <input type="number" class="form-control form-control-sm" v-model="telefono">
                        </div>

                        <div class="col-sm-4 mt-3">
                            <label for="" class="form-label">Días crédito</label>
                            <input type="number" class="form-control form-control-sm" v-model="dias_credito">
                        </div>

                        <div class="col-sm-12 mt-3 mb-3">
                            <button type="submit" class="btn btn-sm btn-outline-dark btn-block">Actualizar</button>
                        </div>
                    </b-row>
                </form>
            </b-container>
        </div>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';

    export default {
        name: 'ActualizarProveedores',
        props: ['item'],
        data() {
            return {
                nombre: '',
                nit: '',
                telefono: '',
                dias_credito: '',
            }
        },
        methods: {
            cerrar() {
                this.$emit('salir')
            },
            async actualizar_info() {
                let f = {
                    api: `proveedores/${this.item.documentId}`,
                    formulario: {
                        nombre_proveedor: this.nombre.trim().toUpperCase(),
                        nit: this.nit,
                        telefono: this.telefono,
                        dias_credito: this.dias_credito == '' ? 0 : this.dias_credito
                    }
                }

                await this.actualizar_data(f)
                await this.obtener_proveedores()
                this.cerrar()
            },
            ...mapActions(['actualizar_data', 'obtener_proveedores'])
        },
        mounted() {
            this.nombre = this.item.nombre_proveedor
            this.nit = this.item.nit
            this.telefono = this.item.telefono
            this.dias_credito = this.item.dias_credito
        },
    }
</script>

<style></style>